module.exports = __webpack_public_path__ + "static/media/time.5f42e5a6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/expect-more/assets/time.jpeg
// module id = 245
// module chunks = 0